import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d20e4606"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "destination__container" }
const _hoisted_2 = { class: "destiny__img" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "destiny__description" }
const _hoisted_5 = { class: "destiny__navigation" }
const _hoisted_6 = { class: "title__name" }
const _hoisted_7 = { class: "paragraph__description" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_9 = { class: "flex__container" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "AVG. DISTANCE", -1))
const _hoisted_11 = { class: "km__days" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "Est. travel time", -1))
const _hoisted_13 = { class: "km__days" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.destinations[_ctx.number].src,
        alt: `Travel destination - ${_ctx.destinations[_ctx.number].title}`
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("ul", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.destinations, (destiny) => {
          return (_openBlock(), _createElementBlock("li", {
            key: destiny.id,
            class: _normalizeClass({ active: _ctx.currentDestiny === destiny.title }),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeDestiny($event)))
          }, _toDisplayString(destiny.title), 3))
        }), 128))
      ]),
      _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.destinations[_ctx.number].title), 1),
      _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.destinations[_ctx.number].paragraph), 1),
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", null, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.destinations[_ctx.number].distance) + " KM", 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.destinations[_ctx.number].time), 1)
        ])
      ])
    ])
  ]))
}